import * as StM  from '../../../store';

export interface IMySessionsPageStoreState {
    sessions: Array<StM.ISessionStoreState>;
}

export class MySessionsPageStoreState implements IMySessionsPageStoreState {
    sessions: Array<StM.ISessionStoreState>;
    constructor() {
        this.sessions = new Array();
    }
}
